import type { SiteDTO } from './site.dto';
import type { IStandard } from '../scheme';
import type { CustomerDTO } from './customer.dto';
import type { InspectorDTO } from './inspector.dto';
import type { IPersonnelPreferrence } from '../personnelPreferrence';
import { UploadedFileDTO } from './uploaded-file.dto';
import type { User } from '../../api/organization';
import { ProjectStandardDTO } from './project-standard.dto';
import type { CompetencyDTO } from './competency.dto';

export enum ProjectStatus {
  INVALID = 'invalid',
  CREATED = 'created',
  DRAFTED = 'drafted',
  SCHEDULED = 'scheduled',
  CLOSED = 'closed',
}

export const PROJECT_STATUS_VALUES: ProjectStatus[] = [
  ProjectStatus.INVALID,
  ProjectStatus.CREATED,
  ProjectStatus.DRAFTED,
  ProjectStatus.SCHEDULED,
  ProjectStatus.CLOSED,
];

export interface ProjectDTO {
  id: number;
  name: string | null;
  dueDate: Date | string;
  orderReference?: string;
  priority: 'HIGH' | 'NORMAL' | 'LOW';
  ownerId?: number|null;
  owner?: User;
  customer?: CustomerDTO;
  preferrences?: IPersonnelPreferrence[];
  excludedPersonnel?: InspectorDTO[];
  preferredPersonnel?: InspectorDTO[];
  sites?: SiteDTO[];
  standards?: IStandard[];
  projectStandards?: ProjectStandardDTO[];
  /** @deprecated List API no longer populates this; use filtered `projectStandards` instead. */
  competencies?: CompetencyDTO[];
  lead?: {id: number; name: string};
  duration?: number;
  durationDays?: number;
  daysBooked?: number;
  files?: UploadedFileDTO[];
  canDelete?: boolean;
  inspectors?: InspectorDTO[];
  status?: ProjectStatus;
  invalidReason?: string | null;
}
